import { NestedObjectsPathKeys, Sorting, SortOptions } from '@connect-x-app/shared-types';

import { Sortable } from './sort';

export abstract class BaseSort<Type extends SortOptions, T extends object> implements Sortable<T, Type> {
  private readonly field: NestedObjectsPathKeys<Required<T>>;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  protected type: Type;

  constructor(field: NestedObjectsPathKeys<Required<T>>) {
    this.field = field;
  }

  parse(): Sorting<T, Type> {
    return `${this.field}:${this.type}`;
  }
}
